import { checkout } from '@consumer/api'
import type { OrderGift, OrderGiftGreeting } from '@consumer/types/serializers'
import { isTest } from '@shared/environment'
import { injectionKey } from '@shared/injection'
import type { ContactData } from './store'
import type { OrderGiftTemplate, OrderItemStepType } from './types'

export * from './checkout'
export * from './store'
export * from './types'

export type DeliveryData = OrderGift['delivery']

export interface WizardApi {
  emailFromParams?: string
  orderGift: Ref<OrderGiftTemplate>
  editWizardStep(step: OrderItemStepType): void
  saveContactStep(changes?: ContactData): Promise<void>
  saveCompletedStep(changes?: Partial<OrderGiftTemplate>): Promise<void>
  refreshOrderGiftDraftGreeting(): Promise<OrderGiftGreeting | undefined | null>
}

const wizardInjectionKey = injectionKey<WizardApi>('wizard')

export function setupWizard (api: WizardApi) {
  provide(wizardInjectionKey, api)
  return api
}

export function useWizard () {
  return inject(wizardInjectionKey)!
}

export function pathToCart (orderGift: OrderGift) {
  // NOTE: Avoid scrolling in integration tests.
  const anchor = isTest ? '' : `#order-gift-${orderGift.id}`
  return `${checkout.cart.path()}${anchor}`
}
